<template>
    <component :is="component" :settings="settings" v-if="component" />
</template>

<script>
    export default {
        name: 'TeamBlazonLoader',
        props: {
            settings: {
                type: Object,
                required: true,
            },
            shape: {
                type: String,
                required: true,
            },
        },
        data () {
            return {
                component: null,
            }
        },
        computed: {
            loader () {
                return () => {
                    return import(`./Shapes/${this.shape}`);
                }
            },
        },
        mounted () {
            this.loader()
                .then(() => {
                    this.component = () => this.loader()
                });
        },
    }
</script>
